import { ImageStatus } from '@web/gen/service/creativefabrica/vectorizer/v2/service_pb'

const SESSION_IMAGES_PAGE_SIZE = 100

export function getSessionImagesVariables(sessionId: string) {
  return {
    sessionId,
    pagination: { take: SESSION_IMAGES_PAGE_SIZE },
  }
}

interface QueryState<TData> {
  state: {
    error: unknown
    data?: TData
  }
}

export function getSessionImagesRefetchInterval(
  query: QueryState<{ pages: Array<{ images?: Array<{ status?: ImageStatus }> }> }>,
) {
  if (query.state.error) {
    return false
  }
  const image = query.state.data?.pages[0]?.images?.[0]
  if (image?.status === ImageStatus.COMPLETED || image?.status === ImageStatus.ERROR) {
    return false
  }
  return 1000
}
